<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <!-- Statistics Card -->
    <div class="card card-statistics">
      <div class="card-header">
        <h4 class="card-title">{{ "STATISTICS" | translate }}</h4>
        <div class="d-flex align-items-center">
          <p class="card-text font-small-2 mr-25 mb-0">{{ "LAST_UPDATE" | translate }}: 2 settimane fa</p>
        </div>
      </div>
      <div class="card-body statistics-body">
        <div class="row">
          <div class="col-sm-6 col-xl-6 mb-2 mb-xl-0">
            <div class="media">
              <div class="avatar bg-light-primary mr-2">
                <div class="avatar-content">
                  <i data-feather="bar-chart" class="avatar-icon"></i>
                </div>
              </div>
              <div class="media-body my-auto">
                <h4 class="font-weight-bolder mb-0">38</h4>
                <p class="card-text font-small-3 mb-0">{{ "ANALYTICS.AGE_OF_EMPLOYEES" | translate }}</p>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-xl-6 mb-2 mb-xl-0">
            <div class="media">
              <div class="avatar bg-light-info mr-2">
                <div class="avatar-content">
                  <i data-feather="user" class="avatar-icon"></i>
                </div>
              </div>
              <div class="media-body my-auto">
                <h4 class="font-weight-bolder mb-0">28%</h4>
                <p class="card-text font-small-3 mb-0">{{ "ANALYTICS.WOMAN_EMPLOYEES" | translate }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--/ Statistics Card -->
    <!-- dipendenti assunti/dimessi -->
    <div class="card card-chart">
      <h4 class="card-title">{{ "ANALYTICS.HIRED_RESIGN" | translate }}</h4>
      <div class="row mx-0">
        <div class="col-md-12 col-12 revenue-report-wrapper">
          <div id="revenue-report-chart">
            <apx-chart [series]="dataHiredResign.series" [colors]="['#ff6600', '#727272']"
              [chart]="chartOptionsHiredResign.chart" [xaxis]="dataHiredResign.xaxis"
              [stroke]="chartOptionsHiredResign.stroke" [yaxis]="chartOptionsHiredResign.yaxis"
              [dataLabels]="chartOptionsHiredResign.dataLabels" [tooltip]="chartOptionsHiredResign.tooltip"
              [legend]="chartOptionsHiredResign.legend"></apx-chart>
          </div>
        </div>
      </div>
    </div>
    <!-- dipendenti assunti/dimessi -->
    <!-- Support Tracker Card -->
    <div class="col-lg-6 col-12">
      <div class="card card-chart">
        <div class="card-header d-flex justify-content-between pb-0">
          <h4 class="card-title">{{ "ANALYTICS.TICKETS_CLOSED" | translate }}</h4>
          <div class="form-group col-xl-4 col-md-6 col-12">
            <label for="resignation-upload">{{ "PERIOD" | translate }}</label>
            <select class="form-control">
              <option value="resignation" selected>{{ "ANALYTICS.LAST_MONTH" | translate }}</option>
              <option value="dismissal">{{ "ANALYTICS.LAST_YEAR" | translate }}</option>
            </select>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-sm-2 col-12 d-flex flex-column flex-wrap text-center">
              <h1 class="font-large-2 font-weight-bolder mt-2 mb-0">
                182
              </h1>
              <p class="card-text">Tickets</p>
            </div>
            <div class="col-sm-10 col-12 d-flex justify-content-center" #supportChartRef>
              <div id="supportChartoptions">
                <apx-chart [series]="dataStateTickets.series" [chart]="chartoptionsStateTickets.chart"
                  [plotOptions]="chartoptionsStateTickets.plotOptions" [colors]="chartoptionsStateTickets.colors"
                  [fill]="chartoptionsStateTickets.fill" [stroke]="chartoptionsStateTickets.stroke"
                  [labels]="dataStateTickets.labels"></apx-chart>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-between mt-1">
            <div class="text-center">
              <p class="card-text mb-50">{{ "ANALYTICS.NEW_TICKETS" | translate }}</p>
              <span class="font-large-1 font-weight-bold">45</span>
            </div>
            <div class="text-center">
              <p class="card-text mb-50">{{ "ANALYTICS.OPEN_TICKET" | translate }}</p>
              <span class="font-large-1 font-weight-bold">78</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--/ Support Tracker Card -->
    <!-- Andamento marginalità -->
    <div class="card card-revenue-budget">
      <div class="row mx-0">
        <div class="col-md-8 col-12 revenue-report-wrapper">
          <div class="d-sm-flex justify-content-between align-items-center mb-3">
            <h4 class="card-title mb-50 mb-sm-0">{{ "ANALYTICS.REVENUE_REPORT" | translate }}</h4>
          </div>
          <div id="revenue-report-chart">
            <apx-chart [series]="dataRevenueReport.series" [chart]="chartOptionsRevenueReport.chart"
              [plotOptions]="chartOptionsRevenueReport.plotOptions" [colors]="chartOptionsRevenueReport.colors"
              [dataLabels]="chartOptionsRevenueReport.dataLabels" [legend]="chartOptionsRevenueReport.legend"
              [grid]="chartOptionsRevenueReport.grid" [xaxis]="chartOptionsRevenueReport.xaxis"
              [yaxis]="chartOptionsRevenueReport.yaxis"></apx-chart>
          </div>
        </div>
        <div class="col-md-4 col-12 budget-wrapper">
          <div class="btn-group">
            <div ngbDropdown>
              <button type="button" class="btn btn-outline-primary btn-sm dropdown-toggle budget-dropdown"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle rippleEffect>
                2020
              </button>
              <div ngbDropdownMenu>
                <a ngbDropdownItem href="javascript:void(0);">2020</a>
                <a ngbDropdownItem href="javascript:void(0);">2019</a>
                <a ngbDropdownItem href="javascript:void(0);">2018</a>
              </div>
            </div>
          </div>
          <h2 class="mb-25">25.000€</h2>
          <div class="d-flex justify-content-center">
            <span class="font-weight-bolder mr-25">Budget:</span>
            <span>55.000€</span>
          </div>
          <div id="budget-chart" #budgetChartRef>
            <apx-chart [series]="dataBudget.series" [chart]="chartOptionsBudget.chart"
              [stroke]="chartOptionsBudget.stroke" [colors]="chartOptionsBudget.colors"
              [tooltip]="chartOptionsBudget.tooltip"></apx-chart>
          </div>
          <button type="button" class="btn btn-primary" rippleEffect>to translate</button>
        </div>
      </div>
    </div>
    <!-- Andamento marginalità -->
    <!-- mappatura skill -->
    <div class="card card-chart">
      <h4 class="card-title">{{ "ANALYTICS.SKILLS" | translate }}</h4>
      <div class="row mx-0">
        <div class="col-md-12 col-12">
          <apx-chart [series]="dataSkills.series" [chart]="chartOptionsSkills.chart" [xaxis]="chartOptionsSkills.xaxis"
            [fill]="chartOptionsSkills.fill" [dataLabels]="chartOptionsSkills.dataLabels"
            [legend]="chartOptionsSkills.legend"></apx-chart>
        </div>
      </div>
    </div>
    <!-- mappatura skill -->
    <!-- candidati inseriti per recruiter -->
    <div class="card card-chart">
      <div class="card-header d-flex justify-content-between pb-0">
        <h4 class="card-title">{{ "ANALYTICS.CANDIDATES_FOR_RECRUITERS" | translate }}</h4>
        <div class="form-group col-xl-4 col-md-6 col-12">
          <label for="resignation-upload">{{ "PERIOD" | translate }}</label>
          <select class="form-control">
            <option value="resignation" selected>{{ "ANALYTICS.LAST_MONTH" | translate }}</option>
            <option value="dismissal">{{ "ANALYTICS.LAST_YEAR" | translate }}</option>
          </select>
        </div>
      </div>
      <div class="row mx-0">
        <div class="col-md-12 col-12">
          <apx-chart [series]="dataCandidatesForRecruiters.series" [chart]="chartOptionsCandidatesForRecruiters.chart"
            [dataLabels]="chartOptionsCandidatesForRecruiters.dataLabels"
            [plotOptions]="chartOptionsCandidatesForRecruiters.plotOptions" [xaxis]="dataCandidatesForRecruiters.xaxis"
            [colors]="chartOptionsCandidatesForRecruiters.colors"></apx-chart>
        </div>
      </div>
    </div>
    <!-- candidati inseriti per recruiter -->
    <!-- candidati resi idonei -->
    <div class="card card-chart">
      <h4 class="card-title">{{ "ANALYTICS.ELIGIBLE_CANDIDATE" | translate }}</h4>
      <div class="row">
        <div class="form-group col-md-6 col-12">
          <label for="contract_start_date">{{ "START_DATE" | translate }}<sup class="text-danger"></sup></label>
          <input type="date" id="contract_start_date" class="form-control" />
        </div>
        <div class="form-group col-12 col-md-6">
          <label for="contract_end_date">{{ "END_DATE" | translate }}<sup class="text-danger"></sup></label>
          <input type="date" id="contract_end_date" class="form-control" />
        </div>
      </div>
      <div class="row mx-0">
        <div class="col-md-12 col-12">
          <apx-chart [series]="dataCandidatesOKKO.series" [chart]="chartOptionsCandidatesOKKO.chart"
            [legend]="chartOptionsCandidatesOKKO.legend" [labels]="dataCandidatesOKKO.labels"
            [plotOptions]="chartOptionsCandidatesOKKO.plotOptions"></apx-chart>
        </div>
      </div>
    </div>
    <!-- candidati resi idonei -->
    <!-- misurazione fatturato costi -->
    <div class="card card-chart">
      <h4 class="card-title">{{ "ANALYTICS.SALES_COSTS" | translate }}</h4>
      <div class="row mx-0">
        <div class="col-md-12 col-12 revenue-report-wrapper">
          <div id="revenue-report-chart">
            <apx-chart [series]="dataSalesCosts.series" [colors]="['#ff6600', '#727272']"
              [chart]="chartOptionsSalesCosts.chart" [xaxis]="dataSalesCosts.xaxis"
              [stroke]="chartOptionsSalesCosts.stroke" [yaxis]="chartOptionsSalesCosts.yaxis"
              [dataLabels]="chartOptionsSalesCosts.dataLabels" [tooltip]="chartOptionsSalesCosts.tooltip"
              [legend]="chartOptionsSalesCosts.legend"></apx-chart>
          </div>
        </div>
      </div>
    </div>
    <!-- misurazione fatturato costi -->
    <!-- costo fatturato e margine per cliente -->
    <div class="card card-chart">
      <h4 class="card-title">{{ "ANALYTICS.EDGE_FOR_CLIENTS" | translate }}</h4>
      <div class="row mx-0">
        <div class="col-md-12 col-12">
          <apx-chart [series]="dataEdgeForClients.series" [chart]="chartOptionsEdgeForClients.chart"
            [dataLabels]="chartOptionsEdgeForClients.dataLabels" [plotOptions]="chartOptionsEdgeForClients.plotOptions"
            [yaxis]="chartOptionsEdgeForClients.yaxis" [fill]="chartOptionsEdgeForClients.fill"
            [stroke]="chartOptionsEdgeForClients.stroke" [tooltip]="chartOptionsEdgeForClients.tooltip"
            [xaxis]="dataEdgeForClients.xaxis" [legend]="chartOptionsEdgeForClients.legend"></apx-chart>
        </div>
      </div>
    </div>
    <!-- costo fatturato e margine per cliente -->
    <!-- Contrattazioni raggruppate per chiuse - annullate - in corso -->
    <div class="card card-chart">
      <h4 class="card-title">{{ "MENU.BARGAINING" | translate }}</h4>
      <div class="row">
        <div class="form-group col-md-6 col-12">
          <label for="contract_start_date">{{ "START_DATE" | translate }}<sup class="text-danger"></sup></label>
          <input type="date" id="contract_start_date" class="form-control" />
        </div>
        <div class="form-group col-12 col-md-6">
          <label for="contract_end_date">{{ "END_DATE" | translate }}<sup class="text-danger"></sup></label>
          <input type="date" id="contract_end_date" class="form-control" />
        </div>
      </div>
      <div class="row mx-0">
        <div class="col-md-12 col-12">
          <apx-chart [series]="dataNegotiation.series" [chart]="chartOptionsNegotiation.chart"
            [labels]="dataNegotiation.labels"></apx-chart>
        </div>
      </div>
    </div>
    <!-- Contrattazioni raggruppate per chiuse - annullate - in corso -->

    <div class="row justify-content-around">
      <!-- Grafico figure professionali dei candidati -->
      <div class="card card-chart width-chart col-md-5">
        <h4 class="card-title">{{ "ANALYTICS.CANDIDATES_ROLE" | translate }}</h4>
        <div class="row mx-0">
          <div class="col-md-12 col-12">
            <apx-chart [series]="dataCandidatesRole.series" [chart]="chartOptionsPie.chart"
              [labels]="dataCandidatesRole.labels" [responsive]="chartOptionsPie.responsive"></apx-chart>
          </div>
        </div>
      </div>
      <!-- Grafico figure professionali dei candidati -->
      <!-- Costi fornitori e di struttura -->
      <div class="card card-chart width-chart col-md-5">
        <div class="d-flex justify-content-between pb-0">
          <h4 class="card-title">{{ "ANALYTICS.PROVIDER_AND_STRUTURAL_COSTS" | translate }}</h4>
          <div class="form-group col-xl-5 col-md-6">
            <label for="resignation-upload">{{ "PERIOD" | translate }}</label>
            <select class="form-control">
              <option value="resignation" selected>{{ "ANALYTICS.LAST_MONTH" | translate }}</option>
              <option value="dismissal">{{ "ANALYTICS.LAST_YEAR" | translate }}</option>
            </select>
          </div>
        </div>
        <div class="row mx-0">
          <div class="col-md-12 col-12">
            <apx-chart [series]="dataProviderAndStruturalCosts.series" [chart]="chartOptionsPie.chart"
              [labels]="dataProviderAndStruturalCosts.labels" [responsive]="chartOptionsPie.responsive"></apx-chart>
          </div>
        </div>
      </div>
      <!-- Costi fornitori e di struttura -->
    </div>

    <div class="row justify-content-around">
      <!-- Figure professionali più richieste per cliente e in generale -->
      <div class="card card-chart width-chart col-md-5">
        <h4 class="card-title">{{ "ANALYTICS.REQUESTED_JOBS" | translate }}</h4>
        <div class="d-inline-block mr-2">
          <label class="d-flex align-items-center mb-0">{{ "CUSTOMER" | translate }}
            <select class="form-control ml-075 pr-3">
              <option>Tutti</option>
              <option>Cliente 1</option>
              <option>Cliente 2</option>
            </select>
          </label>
        </div>
        <div class="row mx-0">
          <div class="col-md-12 col-12">
            <apx-chart [series]="dataMostRequestedJobs.series" [chart]="chartOptionsPie.chart"
              [labels]="dataMostRequestedJobs.labels" [responsive]="chartOptionsPie.responsive"></apx-chart>
          </div>
        </div>
      </div>
      <!-- Figure professionali più richieste per cliente e in generale -->
      <!-- Titoli di studi più comuni fra i dipendenti -->
      <div class="card card-chart width-chart col-md-5">
        <h4 class="card-title">{{ "ANALYTICS.QUALIFICATIONS" | translate }}</h4>
        <div class="row mx-0">
          <div class="col-md-12 col-12">
            <apx-chart [series]="dataQualifications.series" [chart]="chartOptionsPie.chart"
              [labels]="dataQualifications.labels" [responsive]="chartOptionsPie.responsive"></apx-chart>
          </div>
        </div>
      </div>
      <!-- Titoli di studi più comuni fra i dipendenti -->
    </div>
    
    <div class="row justify-content-around">
      <!-- Grafico figure professionali dei dipendenti -->
      <div class="card card-chart width-chart col-md-5">
        <h4 class="card-title">{{ "ANALYTICS.EMPLOYEES_ROLE" | translate }}</h4>
        <div class="row mx-0">
          <div class="col-md-12 col-12">
            <apx-chart [series]="dataEmployeesRole.series" [chart]="chartOptionsPie.chart"
              [labels]="dataEmployeesRole.labels" [responsive]="chartOptionsPie.responsive"></apx-chart>
          </div>
        </div>
      </div>
      <!-- Grafico figure professionali dei dipendenti -->
      <!-- Fatturato clienti -->
      <div class="card card-chart width-chart col-md-5">
        <div class="d-flex justify-content-between pb-0">
          <h4 class="card-title">{{ "ANALYTICS.CLIENT_SALES_VOLUME" | translate }}</h4>
          <div class="form-group col-xl-5 col-md-6">
            <label for="resignation-upload">{{ "PERIOD" | translate }}</label>
            <select class="form-control">
              <option value="resignation" selected>{{ "ANALYTICS.LAST_MONTH" | translate }}</option>
              <option value="dismissal">{{ "ANALYTICS.LAST_YEAR" | translate }}</option>
            </select>
          </div>
        </div>
        <div class="row mx-0">
          <div class="col-md-12 col-12">
            <apx-chart [series]="dataClientSalesVolume.series" [chart]="chartOptionsPie.chart"
              [labels]="dataClientSalesVolume.labels" [responsive]="chartOptionsPie.responsive"></apx-chart>
          </div>
        </div>
      </div>
      <!-- Fatturato clienti -->
    </div>
  </div>
</div>